import React, { StatelessComponent } from 'react';
import b from 'b_';

import './search.stub.css';

import Rect from '@components/rect';

const class_ = b.with('search-page-stub');

const SearchPageStub: StatelessComponent = () => {
    return (
        <div className={class_()}>
            <Rect />
            <Rect />
            <Rect />
            <Rect />
            <Rect />
        </div>
    );
};

export default SearchPageStub;
